import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications

import { JobTypeCourt } from '../../../../shared/models/jobTypeCourt.model';

import { CreateJobTypeComponent} from './../create-job-type.component';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';

import { JobTypeLocation } from '../../../../shared/models/jobTypeLocation.model';
import { JobSubjectServiceType } from '../../../../shared/models/jobSubjectServiceType.model';


@Component({
  selector: 'app-update-subject-service-type',
  templateUrl: './update-subject-service-type.component.html',
  styleUrls: ['./update-subject-service-type.component.css']
})
export class UpdateSubjectServiceTypeComponent implements OnInit {

  model: any;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  get_latest_court_id: Object;
  job_type_court: Object;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: Object;
  job_type_location: Object;


  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_service_rules: any;
  subject_service_type: any;

  constructor(
  private http: HttpClient,
  private _demoService: DemoService,
  private route: ActivatedRoute,
  private router: Router,
  public toastr: HotToastService,
  vcr: ViewContainerRef,
  private modalService: BsModalService, viewRef: ViewContainerRef) { }


  
  ngOnChanges() {
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
   this.getJobServiceRules();
   this.model = new JobSubjectServiceType();
   this.model = this.getSubjectServiceType(this.count);
   


  }

  ngOnInit() {
  }


  getSubjectServiceType(subject_service_type_id) {
    this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
       data => { 
        this.subject_service_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobServiceRules() {
    this._demoService.getJobServiceRules().subscribe(
       data => { this.job_service_rules = data; },
       err => console.log(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }


   updateSubjectServiceType(model) {
    this._demoService.updateSubjectServiceType(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Subject Service Type Updated');
        // run a function in parent component
       this.closeParentModel.emit();
       
       // Subject to reload the manager component parent.
// CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
     console.error(error);
         //return Observable.throw(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }



}
